var map = {
	"./Channel.js": [
		48797
	],
	"./kakaotalk/KakaoTalk.js": [
		73486,
		486
	],
	"./line/Line.js": [
		28947,
		947
	],
	"./viber/Viber.js": [
		91996,
		996
	],
	"./whatsapp/WhatsApp.js": [
		62791,
		791
	],
	"./zalo/Zalo.js": [
		36243,
		243
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 44266;
module.exports = webpackAsyncContext;